const FormLabel = {
  baseStyle: {},
  sizes: {},
  variants: {},
  defaultValues: {},
};

export default FormLabel;
